export default __webpack_public_path__ + "static/media/6.39c88729.jpg";